// external dependencies
import React, { useState, useEffect, useContext } from 'react'
import styled from '@emotion/styled'
import { SearchContext } from './SearchProvider'

// components
import { SearchBlock } from '@jelly/components'

const FORM_HEIGHT = 50

// styled components
const Form = styled.form`
	display: flex;
	align-items: flex-end;
	flex-wrap: nowrap;
	height: ${FORM_HEIGHT}px;
	width: 100%;
`

const SearchInput = styled.input`
	border: none; // to remove default browser input border
	border-bottom: 2px solid ${({ theme }) => theme.colors.orange};
	color: ${({ theme }) => theme.colors.darkGrey};
	font-size: 28px;
	outline: none;
	flex-basis: 85%;
	flex-grow: 1;
`

const SearchSubmit = styled.button`
	border: none;
	cursor: pointer;
	height: ${FORM_HEIGHT}px;
	padding: 0;
	width: ${FORM_HEIGHT}px;
`

function SearchForm() {
	const { handleNewSearch, isLoadingPanelVisible, searchTerm } = useContext(SearchContext)
	const [newSearchTerm, setNewSearchTerm] = useState(searchTerm)

	useEffect(() => {
		setNewSearchTerm(searchTerm) // needed for browser back and forward buttons
	}, [searchTerm])

	const handleSearchSubmit = (newTerm) => {
		handleNewSearch(newTerm)
	}

	return (
		<Form
			onSubmit={(e) => {
				e.preventDefault()
				if (newSearchTerm.trim() !== '') {
					!isLoadingPanelVisible && handleSearchSubmit(newSearchTerm)
				}
			}}
		>
			<SearchInput
				name="search form"
				type="text"
				placeholder="Search..."
				value={newSearchTerm}
				onChange={(e) => setNewSearchTerm(e.target.value)}
			/>
			<SearchSubmit aria-label="Search Button" type="submit">
				<SearchBlock />
			</SearchSubmit>
		</Form>
	)
}
export default SearchForm
